import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg067TravelTicketsColour = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "travel-tickets",
	viewBox: "0 0 752.11 738.92",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-2{fill:#fff}.cls-3{fill:#56cad8}.cls-5{fill:#fed892}.cls-6{fill:#fd8369}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1-2",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m471.89 286.44 52.39 5.56 199.94 21.32.46.05.66.11c13.85 2.21 23.27 17.26 21.46 34.26l-36.88 345.83a35.7 35.7 0 0 1-9.25 20.8c-5 5.29-11.32 8.2-17.78 8.2h-1.64l-.66-.07-199.93-21.37-52.39-5.58zm-1.51-1.87-44 412.49 54.09 5.76 199.93 21.32 1.21.13h1.26c14.27 0 26.87-13.11 28.72-30.52l36.88-345.81c1.91-17.92-8.26-33.79-22.88-36.12l-1.21-.13-199.92-21.36z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M566.23 108.47c29.64 43.66 26.13 107.84 53.31 179 27 71.19 84.69 149.05 83.47 232.69-1 83.47-61 172.38-140.29 195.52-79.08 23.15-177.46-19.81-257.77-68C224.46 599.29 162 545.63 105.05 475 48.06 404.47-3.5 317.14.19 229.81 4 142.66 63.31 55.34 141 20.27S314.77 2.2 394.38 22.2C473.82 42 536.6 64.81 566.23 108.47",
				style: { fill: "#f8f8f8" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M300.14 675.08a19.6 19.6 0 0 1-19.38-17L203.15 74a19.6 19.6 0 0 1 16.81-22l257.93-34.19a20 20 0 0 1 2.57-.17 19.6 19.6 0 0 1 19.39 17l77.6 584.06a19.6 19.6 0 0 1-16.8 22l-257.94 34.21a20 20 0 0 1-2.57.17",
				className: "cls-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M480.46 18.49A18.76 18.76 0 0 1 499 34.73l77.61 584.07a18.77 18.77 0 0 1-16.08 21L302.6 674.07a18 18 0 0 1-2.46.16A18.76 18.76 0 0 1 281.6 658L204 73.93a18.74 18.74 0 0 1 16.07-21L478 18.66a19 19 0 0 1 2.46-.17m0-1.7a20 20 0 0 0-2.68.18L219.85 51.24a20.46 20.46 0 0 0-17.54 22.91l77.61 584.07a20.46 20.46 0 0 0 20.22 17.71 20 20 0 0 0 2.68-.18l257.94-34.27a20.46 20.46 0 0 0 17.53-22.91L500.69 34.5a20.5 20.5 0 0 0-20.23-17.71",
				className: "cls-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m537.36 644.59 23.4-3.11a20.46 20.46 0 0 0 17.53-22.91L500.69 34.5A20.46 20.46 0 0 0 477.78 17l-23.4 3.11Z",
				className: "cls-3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m499.29 228.98-271.61 36.09",
				style: {
					fill: "#fff",
					stroke: "#56cad8",
					strokeMiterlimit: 10,
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 345,
				cy: 142.05,
				r: 70,
				className: "cls-5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m325.06 120.26 56.9 43.55-6.28 8.22-56.91-43.55zm60.95 53.18-3.97-9.55-6.29 8.21z",
				className: "cls-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m363.9 150 .67-40.94-7.18-5.5-11.28 32.83zm-36.97-21.78.28-16.67-2.93-2.24-4.59 13.37zm30.68 30-39.35 11.34-7.18-5.5 28.74-19.46z",
				className: "cls-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m326.93 128.22-16.02 4.62-2.92-2.24 11.7-7.92zM444.7 268.35l41.11 313.03-19.41 2.55-41.1-313.03zm-42.97 6.81 26.2 197.06-19.45 2.58-26.18-197.05z",
				className: "cls-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m336.06 269.43 50.15 377.4",
				style: {
					fill: "#fff",
					stroke: "#56cad8",
					strokeMiterlimit: 10,
					strokeWidth: 2,
					strokeLinecap: "round"
				}
			}),
			/* @__PURE__ */ _jsx("path", { d: "m304.73 288.05.78 5.84-34 4.52-.78-5.84zm8.15 61.33.78 5.84-34 4.52-.78-5.84zm4.55 34.24.78 5.84-34 4.52-.78-5.84zm6.8 51.23.78 5.84-34 4.52-.78-5.84zm-17.13-129 2.27 17.1-34 4.52-2.27-17.1zm6.84 51.55 2.27 17.1-34 4.51-2.27-17.1zm7.44 55.96 2.27 17.1-34 4.52-2.27-17.1zm5.82 43.84 1.14 8.54-34 4.52-1.14-8.54zm-20.96-157.8.3 2.26-34 4.52-.3-2.26zm25.28 190.3.78 5.83-34 4.52-.78-5.84zm2.1 15.82 2.28 17.1-34 4.51-2.28-17.1zm-.84-6.46.3 2.26-34 4.52-.3-2.26zm-7.45-56 .3 2.26-34 4.51-.3-2.26zm1.3 8.38.3 2.26-33.96 4.46-.3-2.26z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M145.12 738.07a23.55 23.55 0 0 1-22.66-17.31l-87.86-321a23.5 23.5 0 0 1 16.47-28.86l39-10.67A51.57 51.57 0 0 0 189.53 333l39-10.67a23.5 23.5 0 0 1 28.88 16.47l87.86 321a23.53 23.53 0 0 1-16.47 28.88l-39 10.67a51.57 51.57 0 0 0-99.47 27.23l-39 10.67a24 24 0 0 1-6.21.82",
				className: "cls-2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M234.73 322.34A22.7 22.7 0 0 1 256.57 339l87.86 321a22.65 22.65 0 0 1-15.87 27.83l-38.19 10.47A52.42 52.42 0 0 0 189.3 726l-38.18 10.45a22.64 22.64 0 0 1-27.84-15.87l-87.86-321a22.7 22.7 0 0 1 15.87-27.83l38.17-10.45a52.42 52.42 0 0 0 101.1-27.67l38.17-10.45a23 23 0 0 1 6-.81m0-1.7a24 24 0 0 0-6.45.87l-39.81 10.86.15.5a50.72 50.72 0 1 1-97.84 26.79c0-.17-.08-.34-.13-.51l-39.81 10.9A24.36 24.36 0 0 0 33.78 400l87.86 321a24.33 24.33 0 0 0 29.92 17.06l39.8-10.89a50.72 50.72 0 1 1 97.85-26.78l39.8-10.9a24.36 24.36 0 0 0 17.06-29.92l-87.86-321a24.4 24.4 0 0 0-23.48-17.93Z",
				style: { fill: "#d37c59" }
			}),
			/* @__PURE__ */ _jsx("path", { d: "m126.57 542.22 3.67-1 26.7 97.57-3.66 1zm37.27-10.2 3.66-1 26.71 97.57-3.66 1zm14.14-6.29 3.65-.98 26.3 97.12-3.65.99zm33.92-6.88 3.67-1 26.71 97.58-3.66 1zm-75.4 20.65 10.74-2.94 26.72 97.58-10.74 2.94z" }),
			/* @__PURE__ */ _jsx("path", { d: "m168.87 530.64 10.74-2.94 26.7 97.58-10.73 2.94zm30.78-8.42 10.73-2.94 26.71 97.58-10.73 2.94zm23.17-6.35 5.36-1.47 26.71 97.58-5.36 1.47zm-93.2 22.89 1.41-.39 26.3 97.13-1.4.38zm110.4-29.74 3.65-.99 26.3 97.13-3.65.98zm13.15-1.46 10.73-2.94 26.72 97.58-10.74 2.94zm-4.06 1.11 1.42-.4 26.71 97.59-1.41.39zm-32.05 8.78 1.42-.39 26.71 97.58-1.42.39z" }),
			/* @__PURE__ */ _jsx("path", { d: "m216.8 515.28 1.42-.38 26.3 97.12-1.4.38z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "m77.76 469.83 88.46-24.21 5.2 18.98-88.46 24.21zm7.08 25.85 44.23-12.1 2.6 9.49-44.23 12.1z",
				className: "cls-3"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 235.95,
				cy: 443.25,
				r: 25.13,
				className: "cls-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m553.57 239.07 198.55 32.97-41.22 248.22-198.55-32.97z",
				className: "cls-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M664.72 721.48h-1.92l-253.64-27L453 283.56l254 27.09.36.07c14.29 2.28 24 17.74 22.17 35.2l-36.88 345.8c-1.78 16.69-14 29.76-27.87 29.76Z",
				className: "cls-2"
			}),
			/* @__PURE__ */ _jsx("path", { d: "m453.72 284.5 52.39 5.58L706 311.41h.46l.67.11c13.84 2.21 23.27 17.26 21.46 34.27l-36.88 345.8a35.8 35.8 0 0 1-9.25 20.8c-5 5.29-11.32 8.2-17.78 8.2h-1.64l-.66-.07-199.9-21.33-52.39-5.58zm-1.51-1.87-44 412.49 54.08 5.77 199.94 21.32 1.21.13h1.27c14.27 0 26.86-13.11 28.72-30.52L730.32 346c1.91-17.93-8.26-33.79-22.89-36.13l-1.22-.13-199.92-21.35z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "m579.34 420.02-97.16 133.3 164.03 17.49z",
				className: "cls-6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M506.21 363.48 664 380.32l-3 27.94-157.77-16.84z",
				className: "cls-3"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 569.74,
				cy: 516.15,
				r: 74.49,
				className: "cls-5"
			})
		]
	})]
});
export default Svg067TravelTicketsColour;
